<!-- 每日學習記錄列表模塊 -->
<template>
    <div class="class-list" id="class-list">
        <div class="an-class" v-for="(item,index) in studyRecord" :key="index" @click="$emit('ck',item)">
            <div class="til" v-if="item.Stats===0 || item.Stats===3">{{item.LearnTypeName}}</div>
            <div class="til2" v-else>{{item.LearnTypeName}}</div>
            <div class="state" v-if="item.Stats===0">{{ $t("StudyRecordStats")[0][0]+item.Times+$t("StudyRecordStats")[0][1]}}</div>
            <div class="state" v-else>{{ $t("StudyRecordStats")[item.Stats]}}</div>
            <div class="next"></div>
        </div>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'DayDoc',
    mixins: [mainDelegate]
}
</script>

<style lang="less" scoped>
@import 'val.less';
@bk: #d8d8d8;
.class-list {
    border-top: solid 1px @bk;
    .an-class {
        position: relative;
        border-bottom: solid 1px @bk;
        text-align: left;
        padding: 0px 18px;
        > div {
            line-height: 30px;
        }
        .til {
            color: @main-color;
            display: flex;
            align-items: center;
            &:before {
                content: '';
                display: inline-block;
                width: 24px;
                height: 24px;
                margin-right: 11px;
                background: url('../assets/img/book.png');
            }
        }
        .til2 {
            color: #d0021b;
            display: flex;
            align-items: center;
            &:before {
                content: '';
                display: inline-block;
                width: 24px;
                height: 24px;
                margin-right: 11px;
                background: url('../assets/img/ic-info-outline.png');
            }
        }
        .state {
            font-size: 16px;
            color: #999;
        }
        .next {
            position: absolute;
            top: 0px;
            right: 20px;
            width: 10px;
            height: 60px;
            background: url('../assets/img/next.png');
            background-repeat: no-repeat;
            background-position: center;
        }
        &:active {
            background: @bk;
        }
        &:hover {
            cursor: pointer;
        }
    }
}
@media only screen and (min-width: @rwd) {
    .class-list {
        border-left: solid 1px @bk;
        border-right: solid 1px @bk;
    }
    #class-list {
        width: 100%;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/DayDoc.vue